import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Theme
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import useRouter from 'use-react-router';
import { PaginatiorInfo } from '../../../../graphql/common.datatypes';
import { Communication, CommunicationTypes } from '../../../../graphql/comms.datatypes';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'relative',
  },
  content: {
    padding: 0
  },
  inner: {
    [theme.breakpoints.up('md')]: {
      minWidth: 700,
    },
  },
  nameCell: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    height: 42,
    width: 42,
    marginRight: theme.spacing(1)
  },
  actions: {
    padding: theme.spacing(1),
    justifyContent: 'flex-end'
  },
}));

const Results = (props: {
  className?: string,
  data: Communication[],
  paginatorInfo: PaginatiorInfo,
  setPage: (page: number) => void,
  rowsPerPage: number,
  setRowsPerPage: (rowsPerPage: number) => void,
}) => {
  const {className, data, paginatorInfo, setPage, rowsPerPage, setRowsPerPage, ...rest} = props;
  const classes = useStyles();
  const {history} = useRouter();

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
    setPage(page + 1);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setRowsPerPage(Number(event.target.value));
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Card>
        <CardHeader
          title="All Comms"
        />
        <Divider/>
        <CardContent className={classes.content}>
          <PerfectScrollbar>
            <div className={classes.inner}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Ident</TableCell>
                    <TableCell>Title</TableCell>
                    <TableCell>Body</TableCell>
                    <TableCell>Method</TableCell>
                    <TableCell>Active</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.map(communication => {
                    const type = CommunicationTypes[communication.communication_type!];

                    return (
                      <TableRow hover key={communication.id} onClick={() => {
                        history.push(`comms/${communication.id}`);
                      }}>
                        <TableCell>{communication.ident}</TableCell>
                        <TableCell>{communication.title}</TableCell>
                        <TableCell>{communication.body}</TableCell>
                        <TableCell>{type.name}</TableCell>
                        <TableCell>{communication.active ? 'active' : 'inactive'}</TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </div>
          </PerfectScrollbar>
        </CardContent>

        <CardActions className={classes.actions}>
          <TablePagination
            component="div"
            count={paginatorInfo.total}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            page={paginatorInfo.currentPage - 1}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[25, 50, 100]}
          />
        </CardActions>
      </Card>
    </div>
  );
};

export default Results;
